export const ConstantsUtils = {
  DateNull: "0001-01-01T00:00:00",
  orderEventStatus: [
    // {
    //     name: 'Procesando',
    //     value: 'Processing',
    // },
    {
      name: "Nuevo",
      value: "New"
    },
    // {
    //     name: 'Cambio de producto aprobado',
    //     value: 'ApprovedProductChange',
    // },
    {
      name: "Gerente zonal recibió los productos",
      value: "ZonalManagerReceivedOldProducts"
    },
    {
      name: "Gigot recibió los productos",
      value: "GigotReceivedOldProducts"
    },
    {
      name: "Gigot envió los productos",
      value: "GigotSendsInOrdersProducts"
    },
    {
      name: "Resuelto",
      value: "Resolved"
    }
  ],
  orderEventStatusSelect: [
    // {
    //     name: 'Procesando',
    //     value: 'Processing',
    // },
    {
      name: "Nuevo",
      value: "New"
    },
    // {
    //     name: 'Cambio de producto aprobado',
    //     value: 'ApprovedProductChange',
    // },
    {
      name: "Gerente zonal recibió los productos",
      value: "ZonalManagerReceivedOldProducts"
    }
    // {
    //     name: 'Gigot recibió los productos',
    //     value: 'GigotReceivedOldProducts',
    // },
    // {
    //     name: 'Gigot envió los productos',
    //     value: 'GigotSendsInOrdersProducts',
    // },
    // {
    //     name: 'Resuelto',
    //     value: 'Resolved',
    // },
  ],
  orderStatus: [
    {
      name: "New",
      value: 0
    },
    {
      name: "Finished",
      value: 1
    },
    {
      name: "PendingDebt",
      value: 2
    },
    {
      name: "Cancelled",
      value: 3
    },
    {
      name: "ReadyForInvoicing",
      value: 4
    },
    {
      name: "Invoiced",
      value: 5
    },
    {
      name: "Picking",
      value: 6
    },
    {
      name: "Transport",
      value: 7
    },
    {
      name: "Returned",
      value: 10
    }
  ],
  orderStatusMap: {
    New: "Abierto",
    Finished: "Cerrado",
    PendingDebt: "Con Deuda",
    Cancelled: "Cancelado",
    ReadyForInvoicing: "Listo para Facturar",
    Invoiced: "Facturado",
    Picking: "Piqueo",
    Transport: "Transporte",
    InvoicingError: "Error en la facturación",
    Returned: "Desarme"
  },
  basketScanningStatus: [
    {
      name: "Invoiced",
      value: 5
    },
    {
      name: "Picking",
      value: 6
    },
    {
      name: "Transport",
      value: 7
    }
  ],
  orderStatusSelect: [
    {
      name: "Invoiced",
      value: "Facturado"
    },
    {
      name: "PendingDebt",
      value: "Con Deuda"
    },
    {
      name: "Cancelled",
      value: "Cancelado"
    },
    {
      name: "InvoicingError",
      value: "Error en la facturación"
    }
  ],
  observationDebtType: [
    {
      name: "Liberado",
      value: 2
    },
    {
      name: "Gerente Zonal asume la deuda",
      value: 3
    },
    {
      name: "Anulado",
      value: 4
    }
  ],
  observationDebtTypeMap: {
    0: null,
    1: "Pendiente",
    2: "Liberado",
    3: "Gerente Zonal asume la deuda",
    4: "Anulado"
  },
  orderEventBasketStatus: [
    {
      name: "Enviado",
      value: 0
    },
    {
      name: "Controlando",
      value: 1
    },
    {
      name: "Recibido",
      value: 2
    }
  ],
  orderEventBasketSecurity: [
    {
      name: "Desconocido",
      value: 0
    },
    {
      name: "Vulnerado",
      value: 1
    },
    {
      name: "Ok",
      value: 2
    }
  ]
};
